import { render, staticRenderFns } from "./historyItem.vue?vue&type=template&id=7c8e67e4&scoped=true"
import script from "./historyItem.vue?vue&type=script&lang=js"
export * from "./historyItem.vue?vue&type=script&lang=js"
import style0 from "./historyItem.vue?vue&type=style&index=0&id=7c8e67e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8e67e4",
  null
  
)

export default component.exports